<template>
    <div style="width: 100%;">
        <div class="row justify-content-center">
            <div v-for="(data, i) in bookingData.monthList" :key="i" class="col-md-1 col-2 p-0">
                <a class="p-2 btn month-btn" 
                    :href="getMonthLink(data)"
                    :class="{'month-btn-actived': data == bookingData.month}"
                >
                    {{ data }}월
                </a>
            </div>
            <!-- dayHeadList -->
            <div class="row p-0 w-100 pt-3 pb-3 mt-2 mb-2" style="background-color: darkgrey;">
                <a v-for="(data, i) in bookingData.dayHeadLineList" :key="i" :href="'#' + data.day + 'day'" 
                    class="day-link"
                    :class="{'disabled': data.day < data.strDay}"
                >
                    <div style="color:white;" v-bind:class="{ 'font-sat': data.text == '토', 'font-sun': data.text == '일' }">                        
                        <span 
                            class="p-2" 
                            v-bind:class="{ 'font-past': data.day < data.strDay, 'selected-day':data.day == data.strDay  }"
                            @click="selectDay(data.day)"
                        >
                            {{ data.day }}
                        </span>
                    </div>
                </a>
            </div>
            <!-- //dayHeadList -->
            <div class="col-lg-12 p-0">
                <div class="col-lg-12 border border-black p-4 mb-2 font-head bg-dayhead">
                    {{ bookingData.year }}년 {{ bookingData.month }}월
                </div>
            </div>
            <!-- box -->
            <div v-for="(data, i) in bookingData.dayList"
                v-bind:class="{ 'bg-satday': data.text == '토', 'bg-sunday': data.text == '일' }"
                class="row col-lg-12 p-0 justify-content-center m-1">
                <div class="col p-0 flex" :id="data.day + 'day'">
                    <div class="col-4 border border-black flex content-center"
                        v-bind:class="{ 'bg-day': data.text !== '토' && data.text !== '일' }">
                        <div>
                            <div>{{ bookingData.month }}월</div>
                            <div>{{ data.day }}일 ({{ data.text }})</div>
                        </div>
                    </div>
                    <div class="col-3 border border-black flex content-center">
                        <div>{{ data.day + 1 }}물</div>
                    </div>
                    <div class="col-5 border border-black  flex content-center">
                        <div>
                            <div><b>태안현아호</b></div>
                            <div class="btn btn-primary" @click="openBookingPage(bookingData.month,data.day, data.fishType)">예약하기</div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 p-0">
                    <div class="col p-0 flex">
                        <div class="col-8 border border-black text-left">
                            <div style="font-size: x-large;">{{ data.subject }}</div>
                            <div>
                                <span class="font-red"><b>어종 :</b></span>
                                <span class="font-blue"><b> {{ data.fishType }}</b></span> / 어초 침선
                            </div>
                            <div>
                                <b>운항시간 :</b>{{ data.strTime }} ~ {{ data.endTime }}
                            </div>
                        </div>
                        <div class="col-4 border border-black flex content-center">
                            <div>
                                <div>남은<br>자리</div>
                                <div class="font-blue"><b>{{ data.leftSeat }}명</b></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- //box -->
        </div>
    </div>
</template>
<script>
import BookingJS from "@/components/booking.js";

export default {
    name: "bookingHome",
    components: {
        BookingJS
    },
    data() {
        return {
            bookingData: BookingJS.getBookingData(),
        }
    },
    mounted() {
        console.log(this.bookingData);
    },
    methods: {
        getMonthLink(month) {
            return `?month=${month}`;
        },
        selectDay(dayNumber) {
            // 모든 요소의 클래스 "selected-day" 제거
            let dayLinks = document.querySelectorAll('.day-link');
            dayLinks.forEach(function (link) {
                link.classList.remove('selected-day');
                link.querySelector('span').classList.remove('selected-day');
            });

            // 선택된 요소에 클래스 "selected-day" 추가
            let selectedElement = document.querySelector('a[href="#' + dayNumber + 'day"]');
            selectedElement.classList.add('selected-day');
            selectedElement.querySelector('span').classList.add('selected-day');
        },
        openBookingPage(month, day, fishType){
            let url = '/writeBooking?month='+month + '&day=' + day + '&fishType=' + fishType;
            let newWindow = window.open(url, '_blank', 'location=no,toolbar=no');
        }
    }
};
</script>
<style>
.flex {
    display: flex;
}

.content-center {
    align-items: center;
    justify-content: center;
}

.font-head {
    font-weight: bold;
    font-size: x-large;
    color: black;
}

.font-red {
    color: red;
}

.font-blue {
    color: skyblue;
}

.bg-dayhead {
    background-color: lightslategrey;
}

.bg-sunday {
    background-color: #f0808069;
}

.bg-satday {
    background-color: #87cefa5e;
}

.bg-day {
    background-color: #dcdcdc54;
}

.month-btn {
    width: 100%;
    border: 1px solid;
    border-radius: 1rem;
}

.month-btn:hover {
    background-color: lightgray;
}

.month-btn:active {
    background-color: #172b4d;
    color: white;
}
.month-btn-actived{
    background-color: #172b4d;
    color: white;
}

.border-black {
    border-color: rgba(0, 0, 0, 52%) !important;
}


.font-sun {
    color: red !important;
}

.font-sat {
    color: #009be8 !important
}

.font-past {
    opacity: .3 !important;
}

.selected-day {
    background-color: lightsteelblue;
    border-radius: 1rem;
}

.disabled {
    pointer-events: none;
    cursor: not-allowed; 
}
</style>
